// extracted by mini-css-extract-plugin
export default {"container":"workZone_container__+omdg","title":"workZone_title__G6uMv","content":"workZone_content__03Jff","image":"workZone_image__vNl1x","text":"workZone_text__6AbFk"};